import { Component, Input } from '@angular/core';
import { ThemeService } from '../../service/theme.service';
import { LoginView } from '../login.component';

@Component({
  selector: 'app-login-mfa-signup',
  templateUrl: './mfa-signup.component.html',
  styleUrls: ['../login.component.css', './mfa-signup.component.css'],
  standalone: false,
})
export class MfaSignupComponent {
  // Context bridge to parent login component
  @Input() ctx: any;
  @Input() loading = false;
  @Input() view!: LoginView;

  constructor(public theme: ThemeService) {}
}
